import { observable } from "mobx";
import AccountingDocumentsInventoryClosureActionRejectionReason from "./accountingDocumentsInventoryClosureActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryClosureActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: AccountingDocumentsInventoryClosureActionRejectionReason;
}
